import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="hero" style={{ '--hero-img': 'url("/images/hero-lagos.jpg")' }}>
      <div className="container">
        <div className="hero-content">
          <span className="section-kicker">AEII · Africa Economic Intelligence Institute</span>
          <h1>La plateforme panafricaine de recherche &amp; d'intelligence économique</h1>
          <p className="lead">
            Accédez à une base documentaire stratégique : rapports, études, notes d'analyse
            et publications scientifiques sur les grands enjeux économiques du continent africain.
          </p>
          <div className="hero-cta">
            <Link to="/publications" className="btn btn-primary">
              Explorer la bibliothèque <i className="fa-solid fa-arrow-right"></i>
            </Link>
            <Link to="/abonnements" className="btn btn-outline">
              Voir les abonnements
            </Link>
          </div>
        </div>

        <div className="hero-stats">
          <div className="hero-stat">
            <strong>500+</strong>
            <span>Publications indexées</span>
          </div>
          <div className="hero-stat">
            <strong>54</strong>
            <span>Pays africains couverts</span>
          </div>
          <div className="hero-stat">
            <strong>120+</strong>
            <span>Chercheurs contributeurs</span>
          </div>
          <div className="hero-stat">
            <strong>12K+</strong>
            <span>Utilisateurs actifs</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;